<template>
  <div class="werk">
    <navbar />

    <caseGrid>
    <div class="row">
        <ul>
          <li v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
          <div class="column intro">  
            <h3>Werk waar we blij van worden</h3>
            <p>Cases die tot stand zijn gekomen door toevallige ontmoetingen, intense brainstormsessies, passie voor het vak, maar vooral door de toffe mensen waar we mee mogen samenwerken.</p>
          </div>
          </li>

          <li v-scroll-reveal="{ delay: 550, viewFactor: 0.5}">   
          <router-link class="router-link" to="/werk/newschain">
            <div class="column newschain-2">
              <img src="../assets/Folded_Paper_case_thumbnail_Newschain.jpg">
              <span class="font-size-custom-max-12">Newschain<br>Product design</span>
            </div>
           </router-link>
          </li>

          <li v-scroll-reveal="{ delay: 550, viewFactor: 0.5}">   
          <router-link class="router-link" to="/werk/team-changing-academy">
            <div class="column tca">
              <img src="../assets/Folded_Paper_case_thumbnail_Team_Changing_Academy.jpg">
              <span class="font-size-custom-max-12">Team Changing Academy<br>Branding & product design</span>
            </div>
           </router-link>
          </li>
         
          <li v-scroll-reveal="{ delay: 550, viewFactor: 0.5}">   
          <router-link class="router-link" to="/werk/avans-hogeschool">
            <div class="column avans">
              <img src="../assets/Folded_Paper_case_thumbnail_Avans_Hogeschool.jpg">
              <span class="font-size-custom-max-12">Avans Hogeschool<br>Product design</span>
            </div>
          </router-link>
          </li>

        <li v-scroll-reveal="{ delay: 550, viewFactor: 0.5}">   
          <router-link class="router-link" to="/werk/gowallet">
            <div class="column gowallet">
              <img src="../assets/Folded_Paper_case_thumbnail_GoWallet.jpg">
              <span class="font-size-custom-max-12">Gowallet<br>Branding & product design</span>
            </div>
          </router-link>
          </li>

          <li v-scroll-reveal="{ delay: 550, viewFactor: 0.5}">  
          <router-link class="router-link" to="/werk/mobilyze">
          <div class="column mobilyze">
            <img src="../assets/Folded_Paper_case_thumbnail_Mobilyze.jpg">
            <span class="font-size-custom-max-12">Mobilyze<br>Branding & product design</span>
          </div>
          </router-link>
          </li>

          <li v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
          <router-link class="router-link" to="/werk/wageningen-universiteit">
          <div class="column unlock">
            <img src="../assets/Folded_Paper_case_thumnail_Unlock.jpg">
            <span class="font-size-custom-max-12">Unlock Wageningen Universiteit & Research <br>Branding & product design</span>
          </div>
          </router-link>
          </li>

          <li v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
          <router-link class="router-link" to="/contact">
            <div class="column end contact-case" id="dotted-column">
              <p>Ook zo'n toffe case? Neem dan contact op</p>
            </div>
          </router-link>
        </li>
      </ul>
    </div>

      <div class="extern-portfolio container-portfolio">
    <h3> Natuurlijk hebben wij meer werk </h3>
    <p> Voor kleinere projecten hebben wij een Behance en Dribbble account. 
      hier vind je veel werk waar we net zo trots op zijn maar net even iets kleiner
      van omvang.
    </p>
    <div class="picture">
      <img src="../assets/Folded_Paper_dribbble-behance.svg">
      <a target="_blank" href="https://www.behance.net/infoe071">
        <div class="behance">
        <!-- <img src="../assets/Folded_Paper_case_thumnail_Unlock.jpg"> -->
      </div>
       </a>
      <a target="_blank" href="https://dribbble.com/folded_paper">
      <div class="dribbble">
        <!-- <img src="../assets/Folded_Paper_case_thumnail_Unlock.jpg"> -->
      </div>
      </a>
    </div>

  </div>
  </caseGrid>

  <footerComponent></footerComponent>

  </div>
</template>

<script>
import navbar from '@/components/generalLayout/navbar.vue';
import caseGrid from '@/components/generalLayout/caseGrid.vue';
import footerComponent from '@/components/specificLayout/footerComponent.vue';

export default {
  name: 'werk',

  components:{
    caseGrid,
    navbar,
    footerComponent
  },
}
</script>

<style lang="scss">

.container-portfolio{
  max-width: 1312px;
  width: 100%;
  margin: 0 auto;
  padding-left: layout-val-64(0.5);
  position: relative;
}
.newschain-2, .avans, .mobilyze, .contact-case {
  float: right;
}
  .work-we-love{
    padding-top: 220px;
  }

  .content-grid-two-rows{
    .column{
      &::after{
        content:'';
        background-image: url(../assets/Folded_Paper_asset_arrow_right.png);
        background-position: right;
        background-size: 100%;
        background-repeat: no-repeat;
        width: 30px;
        height: 30px;
        position: absolute;
        right: 32px;
        bottom: 60px;
        opacity: 0;
        @include transition-cubic-out-back;
        }
      }
   }

.extern-portfolio{
  overflow: hidden; /* will contain if #first is longer than #second */
  margin-bottom: 32px;
  .behance, .dribbble{
    width: 50%;
    position: absolute;
    top:0;
    height: 100%;
      img{
        width: 100%;
      }
  }
  .behance{
    float: left;
    right: 0;
  }
  .dribbble{
    overflow: hidden; /* if you don't want #second to wrap below #first */
    img{
      float: right;
    }
  }
  h3,p{
    max-width: 500px;
  }
}

.picture{
  width: 100%;
  position: relative;
}

@media screen and (max-width: 720px) {
  .content-grid-two-rows{
    .firstenergy, .loud, .newschain, .tca, .newschain-2, .avans, .mobilyze, .contact-case{
      float: none;
    }
  }
  .extern-portfolio{
    padding-left: 0;
  }
}

@media screen and (max-width: 640px) {
  .werk{
    padding-top:0px;
  }
}

</style>
